import { Component, Input, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { initItemsInvoiceParams, NovaPoshtaService } from '../../services/nova-poshta.service';
import { IParams } from '../../model/http';
import { map, Observable, Subject, take, takeUntil } from 'rxjs';
import { AppTableSource, ColumnSortType } from '../../model/table.model';
import { NotificationService } from '../../services/notifications.service';
import { IntegrationService } from '../../services/integration.service';
import { BaseService } from '../../services/base.service';
import { tableHeaders } from './tab-logistic-telegram.interface';
import { MatDialog } from '@angular/material/dialog';
import { ModalService } from '../../services/modal.service';
import { initUsersParams } from '../../services/telegram.service';
import { IError } from '../../interfaces';
import { DEFAULT_ERROR, ERROR_MESSAGES } from '../../enum/constants';
import { LogisticService } from '../../services/logistic.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-tab-logistic-telegram',
  templateUrl: './tab-logistic-telegram.component.html',
  styleUrls: ['./tab-logistic-telegram.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TabLogisticTelegramComponent implements OnInit, OnDestroy {
  private readonly destroy$: Subject<null> = new Subject<null>();

  @Input() apiKey!: any;

  dataSource$: Observable<AppTableSource> = this.logisticService.itemsTg$.pipe(
    map((data) => {
      tableHeaders.map((column) => {
        column.sort = ColumnSortType.NONE;
        if (column.value === this.dataSort?.active) {
          column.sort = this.dataSort.direction;
        }
        return column;
      });
      return {
        headers: tableHeaders,
        rows: data.items,
        pageSize: localStorage?.getItem('channelTake') || data?.size || 0,
        pageIndex: data.page ? data.page - 1 : 0,
        length: data.total || 0,
      };
    }),
  );
  visibleColumns = tableHeaders.map((v) => v.value);

  // Variables

  private itemsRequest: any;
  private dataSort: any;
  public isLoader: boolean = false;
  private timerSearch: any;
  public phoneInput!: string;

  constructor(
    private readonly notificationService: NotificationService,
    private readonly integrationService: IntegrationService,
    private readonly novaPoshtaService: NovaPoshtaService,
    private readonly logisticService: LogisticService,
    public readonly baseService: BaseService,
    public readonly dialog: MatDialog,
    public readonly modalService: ModalService,
  ) {}

  getItemsWithUpdatedParams(params: IParams, isLoader = false) {
    if (this.itemsRequest) {
      this.itemsRequest.unsubscribe();
    }
    this.isLoader = isLoader;
    this.itemsRequest = this.logisticService
      .setQueryItemsTgParams(params)
      .pipe(takeUntil(this.destroy$), take(1))
      .subscribe({
        next: (res) => {
          this.isLoader = false;
        },
        error: (e) => {
          this.isLoader = false;
          (e.error?.errors || []).forEach((err: IError) => {
            this.notificationService.showError('', ERROR_MESSAGES[err.code] || ERROR_MESSAGES[DEFAULT_ERROR]);
          });
        },
      });
  }

  ngOnInit() {
    this.isLoader = true;
    this.logisticService
      .loadItemsTg()
      .pipe(takeUntil(this.destroy$), take(1))
      .subscribe({
        next: () => {
          this.isLoader = false;
        },
        error: (e) => {
          this.isLoader = false;
          (e.error?.errors || []).forEach((err: IError) => {
            this.notificationService.showError('', ERROR_MESSAGES[err.code] || DEFAULT_ERROR);
          });
        },
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }

  onSortChange(sortState: any) {
    this.dataSort = sortState;
    this.getItemsWithUpdatedParams({
      sort: sortState.active,
      order: sortState.direction,
    });
  }

  onPaginationChange(paginationDetails: any) {
    const { pageIndex, pageSize } = paginationDetails;
    localStorage.removeItem('invoiceTake');
    localStorage.setItem('invoiceTake', pageSize);
    this.novaPoshtaService.updateInvoiceTake();
    const page = pageIndex + 1;
    const take = pageSize;
    this.getItemsWithUpdatedParams({ page, take }, true);
  }

  onActionChange(event: any) {
    if (event.label === 'DELETE') {
      this.logisticService
        .removePhoneIntegration(event.id)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: () => {
            this.getItemsWithUpdatedParams({
              ...initItemsInvoiceParams,
            });
          },
        });
    }
  }

  onSearchChange(search: string) {
    if (this.timerSearch) clearTimeout(this.timerSearch);
    this.timerSearch = setTimeout(() => {
      this.getItemsWithUpdatedParams(
        {
          ...initItemsInvoiceParams,
          search,
        },
        true,
      );
    }, 500);
  }

  addPhone() {
    this.logisticService
      .addPhoneIntegration(this.phoneInput)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: () => {
          this.getItemsWithUpdatedParams({
            ...initUsersParams,
          });
          this.phoneInput = '';
        },
        error: (res: any) => {
          (res.error?.errors || []).forEach((err: IError) => {
            if (err.code === 'MAX_INTEGRATION') {
              this.notificationService.showError('', ERROR_MESSAGES[err.code].replace('{0}', 'Telegram'));
            } else {
              this.notificationService.showError('', ERROR_MESSAGES[err.code]);
            }
          });
        },
      });
  }

  protected readonly environment = environment;
}
